module.exports = __webpack_public_path__ + "img/page_left_bottom.8159d694.png";